// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".journal-calendar .v-calendar .v-calendar-weekly__day:not(.v-future):not(.v-outside):hover{cursor:pointer}.journal-calendar .v-calendar .v-calendar-weekly__day.v-future>.v-calendar-weekly__day-label:hover,.journal-calendar .v-calendar .v-calendar-weekly__day.v-outside>.v-calendar-weekly__day-label:hover{cursor:default!important}.journal-calendar .v-calendar .v-calendar-weekly__day.v-outside>.v-calendar-weekly__day-label{color:transparent!important}", ""]);
// Exports
module.exports = exports;
